import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { FileDetails } from '../shared/models/file-details.model';
import { GlobalsService } from '../shared/services/globals.service';
const $ = require('jquery');
@Component({
  selector: 'acr-view-upload-loader',
  template: `<ul class="sidebar-menu" data-widget="tree">
  <li class="header">Want to try your assist module?</li>
  <li class="text-center">
    <acr-file-upload-loader (onFileContentRead)="onFileContentRead($event)"></acr-file-upload-loader>
  </li>
  <li [ngClass]="{'active':(selectedXML.fileLabel === file.fileLabel)}" *ngFor="let file of globalsService.XMLList.Values().reverse()"
     class="treeview">
    <a href="#" (click)="onFileClick(file)">
      <i class="fa fa-book"></i>
      <span class="whitespace">{{file.fileLabel}}</span>
    </a>
  </li>
</ul>
`,
  styles: [``]
})
export class ViewUploadLoaderComponent {

  @Output() onFileSelected: EventEmitter<FileDetails> = new EventEmitter<FileDetails>();

  selectedXML: FileDetails;
  globalsService: GlobalsService;

  constructor(globalsService: GlobalsService) {
    this.globalsService = globalsService;
  }

  onFileContentRead(fileDetails: FileDetails) {
    this.selectedXML = fileDetails;
    if (this.globalsService.XMLList.ContainsKey(fileDetails.fileLabel)) {
      this.globalsService.XMLList.Remove(fileDetails.fileLabel);
    }
    this.globalsService.XMLList.Add(fileDetails.fileLabel, fileDetails);
    this.onFileSelected.emit(fileDetails);
  }
  onFileClick(fileDetails: FileDetails) {
    this.selectedXML = fileDetails;
    this.onFileSelected.emit(fileDetails);

    $('#xmlOnlyMsg').hide();
  }
}
